
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, map } from "rxjs";
import { ConvivaApi } from "src/app/conviva-api";
import { DefaultResponse } from "src/app/shared/models/DefaultResponse";
import { ConvivaErrorHandlingService } from "src/app/shared/services/convivaErrorHandlingService";

@Injectable({
  providedIn: 'root',
})
export class FatosAlunosService {
  private api = ConvivaApi;

  constructor(
    private http: HttpClient,
    private convivaErrorsHandler: ConvivaErrorHandlingService) { }

  public getFatosAlunos(): Observable<DefaultResponse> {
    return this.http.get<DefaultResponse>(this.api.Agendamento.setCadastrarAgendamento)
      .pipe(map((response: DefaultResponse) => response));
  }

  public setExcluirFatoAluno(payload: any): Observable<DefaultResponse> {
    return this.http.post<DefaultResponse>(this.api.CivicoMilitar.FatosAluno.deletarFatosAlunos, payload)
      .pipe(map((response: DefaultResponse) => response));
  }

  public inativarFatosAlunosNovaResolucao(payload: any): Observable<DefaultResponse> {
    return this.http.post<DefaultResponse>(this.api.CivicoMilitar.FatosAluno.inativarFatosAlunosNovaResolucao, payload)
      .pipe(map((response: DefaultResponse) => response));
  }

  public listarFatosAlunosImpactadosNovaResolucao(payload: any): Observable<DefaultResponse> {
    return this.http.post<DefaultResponse>(this.api.CivicoMilitar.FatosAluno.listarFatosAlunosImpactadosNovaResolucao, payload)
      .pipe(map((response: DefaultResponse) => response));
  }

  public getFatoAlunoPorId(id: number): Observable<DefaultResponse> {
    return this.http.get<DefaultResponse>(this.api.CivicoMilitar.FatosAluno.getFatosAlunosById, { params: { idFatoAluno: id } })
      .pipe(map((response: DefaultResponse) => response));
  }

  public setEditarFatosAlunos(payload: any): Observable<DefaultResponse> {
    return this.http.post<DefaultResponse>(this.api.CivicoMilitar.FatosAluno.setEditarFatosAlunos, payload)
      .pipe(map((response: DefaultResponse) => response));
  }
  public setSolicitarEdicaoFatosAlunos(payload: any): Observable<DefaultResponse> {
    return this.http.post<DefaultResponse>(this.api.CivicoMilitar.FatosAluno.setSolicitarEdicaoFatosAlunos, payload)
      .pipe(map((response: DefaultResponse) => response));
  }
  public setAprovarReprovarSolicitacaoFatosAlunos(payload: any): Observable<DefaultResponse> {
    return this.http.post<DefaultResponse>(this.api.CivicoMilitar.FatosAluno.setAprovarReprovarSolicitacaoFatosAlunos, payload)
      .pipe(map((response: DefaultResponse) => response));
  }

  public getSolicitacoesEdicoesFatoAlunoPorCodigoAluno(codigoAluno:number): Observable<DefaultResponse> {
    return this.http.get<DefaultResponse>(this.api.CivicoMilitar.FatosAluno.getSolicitacoesDeEdicaoFatoAlunoPorCodigoAluno, { params:{ codigoAluno } })
      .pipe(map((response: DefaultResponse) => response));
  }






}
